<div *nzModalTitle></div>

<div class="remove-tax-documentation-modal">
  <header class="modal-header">
    <h2>{{ 'profile.removeTaxDocumentationTitle' | translate }}</h2>
    <p>{{ 'profile.removeTaxDocumentationDescription' | translate }}</p>
  </header>

  <div class="document-details">
    @for (row of documentRows; track row.id) {
      <div class="detail-card">
        <span class="detail-card__label">{{ row.label }}</span>
        <span class="detail-card__value">{{ row.value }}</span>
      </div>
    }
  </div>
</div>

<div *nzModalFooter class="modal-footer-actions">
  <korviu-button class="flex-1" color="ghost" size="large" [disabled]="isLoading()" (onclick)="onCancelClick()">
    {{ 'common.cancel' | translate }}
  </korviu-button>
  <korviu-button class="flex-1" color="tertiary" size="large" [loading]="isLoading()" (onclick)="onRemoveClick()">
    {{ 'profile.remove' | translate }}
  </korviu-button>
</div>
